module.exports = __webpack_public_path__ + "img/zhipinban8.aabaa54b.jpg";